import { isPartOfViewport } from "./helper";

export default function animateContentOnScroll() {
  const animatingDomEles = document.querySelectorAll("[data-mb-animate]");
  // on init
  checkAnimationdomEles(animatingDomEles);

  if (animatingDomEles.length > 0) {
    document.addEventListener("scroll", (event) => {
      // on scroll
      checkAnimationdomEles(animatingDomEles);
    });
  }
}

function checkAnimationdomEles(animatingDomEles) {
  for (let i = 0; i < animatingDomEles.length; i++) {
    const direction = animatingDomEles[i].dataset.mbAnimate;
    const innViewport = isPartOfViewport(animatingDomEles[i]);

    if (innViewport) {
      animatingDomEles[i].classList.add("in-viewport");
    } else {
      animatingDomEles[i].classList.remove("in-viewport");
    }
  }
}
